
<template>
  <div class="content-wrap">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8 p-0">
          <div class="page-header">
            <div class="page-title">
              <h1>Administrador de mesas</h1>
            </div>
          </div>
        </div>
        <div class="col-lg-4 p-0">
          <div class="page-header">
            <div class="page-title">
              <ol class="breadcrumb text-right">
               </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="main-content">
        <div class="row">
          <div class="col-lg-12">
           
                            <div class="card">
                                <div class="col-lg-6">
                                   
                                   
                                       <div class="text-left dib">
                                        <div class="stat-heading"><h4>Mesas</h4></div>
                                        <div class="stat-text">Número de mesas: {{total}} </div>
                                        </div>
                                
                                </div>
                                <div class="col-lg-6">
				<button @click="insertTable()" type="button" class="btn btn-primary btn-rounded m-b-10 m-l-5 card-header-right-icon">Añadir mesa</button>
           
                                </div>
                                <br><br>
                            </div>
              
              <div class="col-lg-6">
                  <br>
              	   </div>
          </div>
          <!-- /# column -->
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="card alert">
              <div class="card-header"></div>
              <div class="card-body">
                <div class="col-sm-6">
                  <h4>Crear nuevo código</h4>
                  <h5><i>Selecciona el número de mesa</i></h5>
                  <br />
                  <br />
                
                  <select class="form-control" v-model="selectedTable">
                    <option v-for="mesa in tables" :key="mesa">
                      {{ mesa }}
                    </option>
                  </select>
                 
                </div>
                <div class="col-sm-6">
                  <center>
                    <VueQRCodeComponent
                      v-if="selectedTable != ''"
                      :text="URLWithTable + selectedTable"
                    ></VueQRCodeComponent>
                  </center>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
          <!-- /# column -->
        </div>
        <!-- /# row -->
      </div>
    </div>
  </div>
</template>
<script>
import VueQRCodeComponent from "vue-qrcode-component";
import firebase from "firebase";

export default {
  components: { VueQRCodeComponent },
  data(){
    return {
      tables: [],
      total:0,
      selectedTable: "",
      URLWithTable: "kellner.4bits.mx/welcome?r=1001&t="
    }
  },
  methods:{

    getData(){
    var db = firebase.firestore()
    let temp=[]
db.collection('restaurants/1001/mesas').get().then((subCollectionSnapshot) => {
    subCollectionSnapshot.forEach((subDoc) => {
        console.log(subDoc.data().tableId);
       
       temp.push(subDoc.data().tableId)
     
       
    });
   
     this.tables=temp
     this.tables = this.tables.sort(function(a, b){return a - b});
     console.log(this.tables)
     this.total = this.tables.length
})
    }
   ,

    insertTable(){
       var db = firebase.firestore()
      db.collection("restaurants").doc("1001").collection("mesas").add({
        tableId:(parseInt(this.tables[this.tables.length-1])+1)+"",
        multiUser: false,
        hasCheckedIn: false,
        capacity: 4
      }).then((doc) => {
        // ON SUCCESS
        console.log(doc)
        window.location.reload();
     
      }).catch((err) => {
        // CATCH FAILURE
        console.log(err)
      })
     // 

    }
  },
  mounted(){
    this.getData()
    this.insertTable
  }
};
</script>